import { useSelector } from 'react-redux'
import { selectAccount, selectBalance } from '../../modules/web3/selectors'

const useIsWalletConnected = () => {
  const balance = useSelector(selectBalance)
  const account = useSelector(selectAccount)
  return Boolean(balance && account)
}

export default useIsWalletConnected
